var _path, _line;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIcnEditS = function SvgIcnEditS(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.5468 12.3319L2.55278 10.4758L7.72458 5.33713L9.5983 7.17585L4.40295 12.3379L2.5468 12.3319ZM10.6625 6.11853L11.721 5.06674C11.8679 4.92077 11.8687 4.68333 11.7227 4.53642L10.4012 3.20633C10.2552 3.05941 10.0178 3.05865 9.87085 3.20462L8.78873 4.2798L10.6625 6.11853ZM5.20309 13.6574C5.0855 13.7742 4.92632 13.8396 4.76056 13.839L1.66698 13.8291C1.32181 13.828 1.04289 13.5472 1.044 13.2021L1.05395 10.1085C1.05448 9.94274 1.12084 9.78398 1.23843 9.66714L8.81361 2.14056C9.54819 1.41068 10.7354 1.4145 11.4652 2.14909L12.7868 3.47917C13.5167 4.21376 13.5129 5.40094 12.7783 6.13081L5.20309 13.6574Z",
    fill: "currentcolor"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 7.75,
    y1: 13.1094,
    x2: 14.6875,
    y2: 13.1094,
    stroke: "currentcolor",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcnEditS, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icn_edit_s.06f9bd80.svg";
export { ForwardRef as ReactComponent };